import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';

export default class ViewDataItem extends Component {
  render() {
    return (
      <div className="data-view-group row">
        <div className="col-sm-4">{this.props.label} :</div>
        <div className="col-sm-8">{this.props.text}</div>
      </div>
    );
  }
}

ViewDataItem.propTypes = {
  label: PropTypes.array.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/components/ViewDataItem/index.js
 **/